import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface CameraBookmark {
  zoom: number;
  x: number;
  y: number;
  label?: string;
}

interface CameraBookmarksState {
  bookmarks: Record<string, CameraBookmark | null>; // keys '1'..'9'
  saveBookmark: (key: string, bookmark: CameraBookmark) => void;
  clearBookmark: (key: string) => void;
  getBookmark: (key: string) => CameraBookmark | null;
}

export const useCameraBookmarksStore = create<CameraBookmarksState>()(
  persist(
    (set, get) => ({
      bookmarks: {},
      saveBookmark: (key, bookmark) => set((s) => ({ bookmarks: { ...s.bookmarks, [key]: bookmark } })),
      clearBookmark: (key) => set((s) => ({ bookmarks: { ...s.bookmarks, [key]: null } })),
      getBookmark: (key) => get().bookmarks[key] ?? null,
    }),
    { name: 'spine-camera-bookmarks' }
  )
);
